import { useMutation, useQuery } from 'react-query';
import {
  acceptInvitation,
  getInvitationName,
  invitationValidate,
  validateSmsOtp,
} from '~/api/invitation';
import { useReduxState } from '~/hooks';

export const useValidateInvitation = () => {
  return useMutation(invitationValidate);
};

export const useValidateOtpInvitation = () => {
  return useMutation(validateSmsOtp, {
    onError: () => {},
  });
};

export const useAcceptInvitation = () => {
  return useMutation(acceptInvitation, {
    onError: () => {},
  });
};

export const useExistingCompany = () => {
  return useReduxState<{ legalName?: string } | undefined>('existingCompany', undefined);
};

export const useGetInvitationName = () => useQuery('invitationName', getInvitationName);
